import React, { Component } from 'react';

require('./InfoCard.scss');


class InfoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { infoCard } = this.props;
    if (!infoCard) { return null; }
    return (
      <div className="tooltipHeader">
        <img src={require('@images/description-hover.png')} alt="." />
        <div className="tooltiptext">{infoCard && infoCard.map(({ header, amount, text }) =>
          <div className="tooltipContainer" key={header}>
            <div className="amountContainer">
              <div>{header}</div>
              <div>{amount}</div>
            </div>
            <div>{text}</div>
          </div>)}</div>
      </div>

    );
  }
}

InfoCard.defaultProps = {
  infoCard: null
};

export default InfoCard;
